// This file contains css class names in full, this is needed for tailwind to
// include them in the final bundle.

export const tvrnColors = [
  "gray",
  "mauve",
  "orange",
  "bronze",
  "green",
  "teal",
  "blue",
  "lavender",
] as const;

export type TvrnColor = (typeof tvrnColors)[number];

export const tvrnColorByIndex = (index = -1): (typeof tvrnColors)[number] =>
  tvrnColors[index] ?? tvrnColors[0];

export const tvrnColorBackgroundClass = (color: TvrnColor): string =>
  ({
    gray: "bg-tvrn-gray",
    mauve: "bg-tvrn-mauve",
    orange: "bg-tvrn-orange",
    bronze: "bg-tvrn-bronze",
    green: "bg-tvrn-green",
    teal: "bg-tvrn-teal",
    blue: "bg-tvrn-blue",
    lavender: "bg-tvrn-lavender",
  })[color];

export const tvrnColorTextClass = (color: TvrnColor): string =>
  ({
    gray: "text-tvrn-on-gray",
    mauve: "text-tvrn-on-mauve",
    orange: "text-tvrn-on-orange",
    bronze: "text-tvrn-on-bronze",
    green: "text-tvrn-on-green",
    teal: "text-tvrn-on-teal",
    blue: "text-tvrn-on-blue",
    lavender: "text-tvrn-on-lavender",
  })[color];
